"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var CustomerItem = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(CustomerItem, _Vue);
  var _super = (0, _createSuper2.default)(CustomerItem);
  function CustomerItem() {
    var _this;
    (0, _classCallCheck2.default)(this, CustomerItem);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "customer", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isSelected", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "visibleSelect", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "unCheckImg", require("@/assets/images/oval.png"));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "checkImg", require("@/assets/images/check.png"));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "avatarDefault", require("@/assets/images/avatar_default.svg"));
    return _this;
  }
  (0, _createClass2.default)(CustomerItem, [{
    key: "onClick",
    value: function onClick() {
      return this.customer;
    }
  }]);
  return CustomerItem;
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], CustomerItem.prototype, "customer", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: false
})], CustomerItem.prototype, "isSelected", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: false
})], CustomerItem.prototype, "visibleSelect", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Emit)("onClick")], CustomerItem.prototype, "onClick", null);
CustomerItem = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], CustomerItem);
var _default = CustomerItem;
exports.default = _default;